module.exports = __webpack_public_path__ + "static/media/lightbulb.a5fde795.svg";